import type { AuthorizationState, RequestContext } from "./types";
import type { IPinFormState } from "../../../../store/pinFormStore";
import type { LoginFormState } from "../../../../store/loginFormStore";
import { useAuthorizationStore } from "../../../../store/authorizationStore";
import { AUTH_MESSAGES, validateCredentials } from "../../../../api/newAuthorization";

interface PinContext extends RequestContext {
  auth: Pick<AuthorizationState, "authSessionId" | "deviceId" | "restoringPin" | "flow" | "passportChecked">;
  login: Pick<LoginFormState, "clearPhoneForm" | "clearSMSForm" | "clearForm">;
  pin: Pick<IPinFormState, "pin" | "reset">;
}

export async function submitPin({ auth, login, pin, request, isCurrent, navigate }: PinContext) {
  const session = auth.authSessionId;
  const deviceLogin = !session && !!auth.deviceId && !auth.restoringPin;
  const creating = auth.restoringPin || auth.flow === "REG";

  if ((!session && !deviceLogin) || (auth.flow === "REG" && !auth.passportChecked)) {
    throw new Error(AUTH_MESSAGES.pin);
  }

  const path = deviceLogin
    ? `/devices/${encodeURIComponent(auth.deviceId!)}/pin/validate`
    : `/sessions/${encodeURIComponent(session!)}/pin${creating ? "" : "/check"}`;
  const data = await request(path, { pin: pin.pin }, auth.restoringPin ? "PUT" : "POST");
  if (!isCurrent()) {
    return;
  }

  const credentials = validateCredentials(data, !deviceLogin);
  useAuthorizationStore.setState({
    ...credentials,
    deviceId: deviceLogin ? auth.deviceId : credentials.deviceId,
    otpSessionUuid: undefined,
    authSessionId: undefined,
    flow: undefined,
    restoringPin: false,
    passportChecked: false,
  });
  login.clearPhoneForm();
  login.clearSMSForm();
  login.clearForm();
  pin.reset();
  navigate("/", { replace: true });
}
